// I passi della procedura «Nuovo progetto» (tela, artboard 31–34): fatti, quello aperto, i
// prossimi. Si torna a un passo già fatto cliccandolo.
import { Icon } from '../../../components/Icon';

export const STEPS = ['Origine', 'Requisiti', 'Team e piano', 'Riepilogo'] as const;

export function Stepper({ at, onGo }: { at: number; onGo: (step: number) => void }) {
  return (
    <ol className="np-stepper" aria-label="Passi">
      {STEPS.map((name, i) => {
        const done = i < at;
        const state = done ? 'done' : i === at ? 'on' : 'next';
        return (
          <li key={name} data-state={state}>
            <button
              type="button"
              disabled={!done}
              aria-current={i === at ? 'step' : undefined}
              onClick={() => onGo(i)}
            >
              <span className="np-dot">{done ? <Icon name="check" size={13} /> : i + 1}</span>
              <span className="np-label">{name}</span>
            </button>
            {i < STEPS.length - 1 && <span className="np-line" aria-hidden="true" />}
          </li>
        );
      })}
    </ol>
  );
}
